import { render } from "./RoleData.vue?vue&type=template&id=6f317cea"
import script from "./RoleData.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleData.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/users/RoleData.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f317cea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f317cea', __exports__)) {
    console.log('reload')
    api.reload('6f317cea', __exports__)
  }
  
  module.hot.accept("./RoleData.vue?vue&type=template&id=6f317cea", () => {
    console.log('re-render')
    api.rerender('6f317cea', render)
  })

}


export default __exports__